import { render } from "./SplashScreen.vue?vue&type=template&id=351c4440&scoped=true"
import script from "./SplashScreen.vue?vue&type=script&lang=js"
export * from "./SplashScreen.vue?vue&type=script&lang=js"

import "./SplashScreen.vue?vue&type=style&index=0&id=351c4440&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351c4440"]])

export default __exports__